const seeds = [
  {
    name: "swamp",
    colour: "#7d8c3a",
  },
  {
    name: "castle",
    colour: "#5742b7"
  }
];

const pieces = {
  i: {
    shape: [[1, 1, 1, 1]],
    centre: [1.5, 0.5],
    colour: "#7FDBFF",
  },
  t: {
    shape: [
      [0, 1],
      [1, 1, 1],
    ],
    centre: [1, 1],
    colour: "#5742b7",
  },
  z: {
    shape: [
      [1, 1],
      [0, 1, 1],
    ],
    centre: [1, 1],
    colour: "#FF4136"
  },
  s: {
    shape: [
      [0, 1, 1],
      [1, 1],
    ],
    centre: [1, 1],
    colour: "#2ECC40"
  },
  o: {
    shape: [
      [1, 1],
      [1, 1],
    ],
    centre: [0.5, 0.5],
    colour: "#FFDC00"
  },
  l: {
    shape: [
      [0, 0, 1],
      [1, 1, 1],
    ],
    centre: [1, 1],
    colour: "#0074D9"
  },
  j: {
    shape: [
      [1, 0, 0],
      [1, 1, 1],
    ],
    centre: [1, 1],
    colour: "#FF851B"
  },
};

// Data source: https://tetris.fandom.com/wiki/SRS
// "Super Rotation System"

const I_WALLKICK_DATA = {
  "01": [
    [0, 0],
    [-2, 0],
    [1, 0],
    [-2, -1],
    [1, 2],
  ],
  10: [
    [0, 0],
    [2, 0],
    [-1, 0],
    [2, 1],
    [-1, -2],
  ],
  12: [
    [0, 0],
    [-1, 0],
    [2, 0],
    [-1, 2],
    [2, -1],
  ],
  21: [
    [0, 0],
    [1, 0],
    [-2, 0],
    [1, -2],
    [-2, 1],
  ],
  23: [
    [0, 0],
    [2, 0],
    [-1, 0],
    [2, 1],
    [-1, -2],
  ],
  32: [
    [0, 0],
    [-2, 0],
    [1, 0],
    [-2, -1],
    [1, 2],
  ],
  30: [
    [0, 0],
    [1, 0],
    [-2, 0],
    [1, -2],
    [-2, 1],
  ],
  "03": [
    [0, 0],
    [-1, 0],
    [2, 0],
    [-1, 2],
    [2, -1],
  ],
};

const OTHER_WALLKICK_DATA = {
  "01": [
    [0, 0],
    [-1, 0],
    [-1, 1],
    [0, -2],
    [-1, -2],
  ],
  10: [
    [0, 0],
    [1, 0],
    [1, -1],
    [0, 2],
    [1, 2],
  ],
  12: [
    [0, 0],
    [1, 0],
    [1, -1],
    [0, 2],
    [1, 2],
  ],
  21: [
    [0, 0],
    [-1, 0],
    [-1, 1],
    [0, -2],
    [-1, -2],
  ],
  23: [
    [0, 0],
    [1, 0],
    [1, 1],
    [0, -2],
    [1, -2],
  ],
  32: [
    [0, 0],
    [-1, 0],
    [-1, -1],
    [0, 2],
    [-1, 2],
  ],
  30: [
    [0, 0],
    [-1, 0],
    [-1, -1],
    [0, 2],
    [-1, 2],
  ],
  "03": [
    [0, 0],
    [1, 0],
    [1, 1],
    [0, -2],
    [1, -2],
  ],
};

export { pieces, seeds, OTHER_WALLKICK_DATA, I_WALLKICK_DATA };
